import { get, post, destroy, patch } from 'stores/_services/dataService';

export interface IBox {
    accountCount: number;
    applicationCount: number;
    artifactCount: number;
    autostartCount: number;
    connectionCount: number;
    data: {
        counts: {
            compromised: {
                accounts: number;
                artifacts: number;
                autostarts: number;
                drivers: number;
                files: number;
                hosts: number;
                memory: number;
                modules: number;
                processes: number;
                scripts: number;
            };
            total: {
                accounts: number;
                artifacts: number;
                autostarts: number;
                drivers: number;
                files: number;
                hosts: number;
                memory: number;
                modules: number;
                processes: number;
                scripts: number;
                totalHosts: number;
            };
        };
    };
    driverCount: number;
    filterOn: Date;
    hookCount: null;
    hostCount: number;
    id: string;
    lastScannedOn: Date;
    memoryCount: number;
    moduleCount: number;
    name: string;
    processCount: number;
    refreshOn: null;
    refreshedOn: Date;
    scriptCount: number;
    targetId: null | string;
    timeWindow: null | {
        days: number;
    };
    totalHostCount: number;
    createdBy: string;
    filter: {
        startDate: string;
        endDate: string;
        flag: any[];
        threat: any[];
        scanOptions: any[];
    };
}

interface ICreateBox {
    name: string;
    targetId: null | string;
    createdBy: string;
    createdOn: string;
    filter: {
        startDate: string;
        endDate: string;
        flag: any[];
        threat: any[];
        scanOptions: any[];
    };
}

export interface ICreateBoxServerError {
    statusCode: number;
    message: string;
}

class BoxService {
    boxes = new Map<string, IBox>();

    findBox(boxId: string): IBox | undefined {
        return this.boxes.get(boxId);
    }

    async getBoxes(force = false, targetId?: string): Promise<Map<string, IBox>> {
        if (force && this.boxes.size) {
            return this.boxes;
        }

        const options = {
            filter: {
                where: { targetId }
            }
        };

        const { data } = await get('boxes', options);

        for (const i in data) {
            this.boxes.set(data[i].id, data[i]);
        }

        return this.boxes;
    }

    async getBox(boxId: string, force?: boolean): Promise<IBox | undefined> {
        if (!force && this.boxes.has(boxId)) {
            return this.boxes.get(boxId);
        }

        const { data } = await get(`boxes/${boxId}`);

        this.boxes.set(boxId, data);

        return data;
    }

    async createBox(payload: ICreateBox): Promise<void> {
        await post('boxes', payload);
    }

    async updateBox(boxId: string | undefined, payload: ICreateBox): Promise<void> {
        await patch(`boxes/${boxId}`, payload);
    }

    async deleteBox(boxId: string): Promise<void> {
        await destroy(`boxes/${boxId}`);
    }
}

export default new BoxService();
